import React, { useState, useEffect } from 'react';
import './call-kpi.scss';
import overallIcon from '../../images/overall.svg';
import { useTranslate } from '../../lib'

const CallKPI = ({ data, onSeekToTime }) => {
  const [kpiData, setKpiData] = useState({
    overall_performance_score: 0,
    sections_evaluation: []
  });
  const { t } = useTranslate();
  useEffect(() => {
    console.log('KPI data received:', data);
    
    // Extraemos los datos KPI de la ubicación correcta
    if (data && data.kpi) {
      setKpiData({
        overall_performance_score: data.kpi.overall_performance_score || 0,
        sections_evaluation: data.kpi.sections_evaluation || [],
        industry: data?.industry
      });
    }
  }, [data]);

  const getScoreColor = (score) => {
    if (score >= 7) {
      return '#4CAF50'; // Verde para puntajes altos
    } else if (score >= 5) {
      return '#FFC107'; // Amarillo para puntajes medios
    } else {
      return '#F44336'; // Rojo para puntajes bajos
    }
  };

  return (
    <div className="call-kpi-container">
      <div className="kpi-metrics-container">
        {/* Overall Performance Score - Simplificado */}
        <div className="overall-score-simple">
          <div className="overall-left">
            <div className="overall-title">
              <img src={overallIcon} width="30" alt="Overall Performance" />
              <span>{t('reports.kpi.overallPerformance')}</span>
            </div>
            <div 
              className="overall-score-circle" 
              style={{ backgroundColor: getScoreColor(kpiData.overall_performance_score) }}
            >
              {kpiData.overall_performance_score || 0}
            </div>
          </div>
        </div>
        
        {/* Section Evaluations */}
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', margin: 5, fontSize: 14, color: '#4e4e4e'}}>
          <div style={{fontWeight: 'bold', marginRight: 5}}>{t('common.industry')}:</div>
          <div>{kpiData?.industry}</div>
        </div>
        
        {kpiData.sections_evaluation && kpiData.sections_evaluation.length > 0 ? (
          <table className="sections-table">
            <thead>
              <tr>
                <th className="section-column">{t('reports.kpi.section')}</th>
                <th className="score-column">{t('common.score')}</th>
                <th className="reason-column">{t('common.description')}</th>
              </tr>
            </thead>
            <tbody>
              {kpiData.sections_evaluation.map((section, index) => (
                <tr key={index} className="section-row">
                  <td className="section-cell">
                    <div className="section-number-container">
                      <div className="section-number">{index + 1}</div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span className="section-title">{section.section || `${t('reports.kpi.section')} ${index + 1}`}</span>
                      {section.evidence_timestamps && section.evidence_timestamps.length > 0 && section.evidence_timestamps[0].timestamp && section.evidence_timestamps[0].timestamp !== 'unknown' && section.evidence_timestamps[0].timestamp !== '00:00:00' && section.evidence_timestamps[0].timestamp.trim() !== '' && (
                        <span 
                          className="section-title" 
                          style={{ fontWeight: 'normal', cursor: 'pointer', color: '#0B5FA3' }}
                          onClick={() => onSeekToTime && onSeekToTime(section.evidence_timestamps[0].timestamp)}
                        >
                          Recorded time: <span style={{ textDecoration: 'underline' }}>{section.evidence_timestamps[0].timestamp}</span>
                        </span>
                      )}
                    </div>
                  </td>
                  <td className="score-cell">
                    <div 
                      className="score-circle" 
                      style={{ backgroundColor: getScoreColor(section.score) }}
                    >
                      {section.score || 0}
                    </div>
                  </td>
                  <td className="reason-cell">
                    {section.reason || t('reports.kpi.noReasonAvailable')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="no-data-message">{t('reports.kpi.noSection')}</div>
        )}
      </div>
    </div>
  );
};

export default CallKPI;